<template>
    <div id="workLogEntryGrid">

        <b-form-checkbox v-model="emptyExecutionsEnabled" @change="resetGrid()">
            Show Executions with 0 attachments.
        </b-form-checkbox>

        <ejs-grid
                  ref="dataRetentionExecutionGridRow"
                  :dataSource="gridData"
                  :queryCellInfo="customiseCell"
                  :contextMenuItems="contextMenuItems"
                  :contextMenuClick="contextMenuClicked"
                  :contextMenuOpen="contextMenuOpened"
                  :rowDataBound='rowDataBound'
                  :headerCellInfo="headerCellInfoEvent">
            <e-columns>
                <e-column field="createdDateTimeUTC" headerText="Initialized Date" width="140"></e-column>
                <e-column field="matchingAttachments" headerText="Number of Attachments"></e-column>
                <e-column field="status.displayName" headerText="Status"></e-column>
                <e-column field="messages" headerText="Message"></e-column>
            </e-columns>
        </ejs-grid>

        <button v-if="gridData != null && gridData.count > gridData.result.length"
                type="button"
                class="btn btn-secondary mt-2"
                @click="loadMoreExecutions()">
            Load More
        </button>

    </div>
</template>

<script>
    import Vue from 'vue';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import NumbersMixin from '../../mixins/NumbersMixin';
    import axios from 'axios';
    import GridMixins from '../../mixins/GridMixins';

    import { extend, localize } from 'vee-validate';
    import { required, min_value, max_value, email } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    extend('min_value', min_value);
    extend('max_value', max_value);
    extend('email', email);
    localize('en', en);

    import { GridPlugin, ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
    Vue.use(GridPlugin);

    export default {
        name: 'DataRetentionExecutionGridRow',
        emits: {
            updateLogEntry: null,
        },
        inject: {
            eventBus: { from: 'eventBus' }
        },
        provide: {
            grid: [ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport, ContextMenu]
        },
        mixins: [DateTimeMixin, NumbersMixin, GridMixins],
        data() {
            return {
                data: {},
                gridData: { result: [], count: 0 },
                pageNumber: 0,
                emptyExecutionsEnabled: false,
                columnFormats: {
                    'createdDateTimeUTC': {
                        type: 'datetime',
                    },
                    'completedDateTime': {
                        type: 'datetime',
                    },
                    'confirmedDateTime': {
                        type: 'datetime',
                    },
                    'cancelledDateTime': {
                        type: 'datetime',
                    },
                },
                contextMenuItems: [
                    { text: "Confirm Execution", iconCss: "fas fa-check", id: "confirmexecution" },
                    { text: "View Affected Files", iconCss: "fas fa-paperclip", id: "viewfiles" },
                ],

            }
        },
        methods: {

            rowDataBound: function () {
                //if (this.data.selectedEntry != undefined &&
                //    this.data.selectedEntry != null &&
                //    args.data.workLogEntryId == this.data.selectedEntry)
                //    args.row.classList.add('selectedWorkLogEntry');
                return;
            },
            customiseCell: function (args) {
                this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
            },
            contextMenuOpened: function (args) {
                if (args.rowInfo.rowData === undefined || args.rowInfo.rowData == null) {
                    args.cancel = true;
                    return;
                }

                var contextMenuObj = this.$refs.dataRetentionExecutionGridRow.ej2Instances.contextMenuModule.contextMenu;
                var item = args.rowInfo.rowData;
                var hasItems = false;

                if (item.status.stringValue != "ConfirmationRequired") contextMenuObj.hideItems(["confirmexecution"], true);
                else {
                    contextMenuObj.showItems(["confirmexecution"], true);
                    hasItems = true;
                }

                if (item.status.stringValue != "Success" || item.matchingAttachments == 0) contextMenuObj.hideItems(["viewfiles"], true);
                else {
                    contextMenuObj.showItems(["viewfiles"], true);
                    hasItems = true;
                }

                if (item.status.stringValue != "ConfirmationRequired") contextMenuObj.hideItems(["confirmexecution"], true);
                else {
                    contextMenuObj.showItems(["confirmexecution"], true);
                    hasItems = true;
                }

                if (!hasItems) args.cancel = true;
            },
            contextMenuClicked: function (args) {
                if (args.item.id === 'confirmexecution' || args.item.id === 'viewfiles') {
                    if (args.rowInfo === undefined || args.rowInfo.rowData === undefined) return;
                    this.handleAction(args.item.id, args.rowInfo.rowData);
                }
            },
            handleAction: function (action, selectedRow) { //, selectedRow
                //var row = {};
                switch (action) {
                    case ('confirmexecution'):
                        this.confirmExecution(selectedRow.dataRetentionExecutionId);
                        break;
                    case ('viewfiles'):
                        this.eventBus.$emit('viewfiles', selectedRow);
                        break;
                    default:
                        break;
                }
            },
            resetGrid: function () {
                this.gridData = { result: [], count: 0 };
                this.pageNumber = 0;
                this.loadExecutions();
            },
            getEntryRowIndex: function (id) {
                var rowIndex = this.gridData.result.findIndex(i => { return i.workLogEntryId == id; });
                return rowIndex;
            },
            confirmExecution: function (executionId) {
                var url = this.$urlHelper.getApiUrl('DataRetention', 'confirmexecution', [executionId]);

                return axios
                    .get(url)
                    .then(() => {
                        this.resetGrid();
                        this.$bvToast.toast('Execution has been confirmed to run on next iteration.', {
                            title: 'Execution Confirmed',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },
            loadMoreExecutions: function () {
                this.pageNumber++;
                this.loadExecutions();
            },
            loadExecutions: function () {
                var url = this.$urlHelper.getApiUrl('DataRetention', 'listexecutions', [this.data.id, this.pageNumber, this.emptyExecutionsEnabled]);

                return axios
                    .get(url)
                    .then(response => {
                        //this.gridData = response.data;
                        var combinedArray = this.gridData.result.concat(response.data.result);
                        this.gridData = {
                            result: combinedArray,
                            count: response.data.count
                        }

                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },
        },
        mounted() {
            this.loadExecutions();
        },
    }







</script>